// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__Juono","right":"Footer_right__2jTwC","buttons":"Footer_buttons__2qjoz"};